import React, { useEffect } from 'react';
import {
  SideNavItems,
  SideNavLink,
  SideNav,
  SideNavMenu,
  SideNavMenuItem,
} from '@carbon/react';


import {
  UserMultiple,
  InventoryManagement,
  ChartNetwork,
  Industry,
  Bullhorn,
  Categories,
  Calendar,
  Tag,
  PlayFilledAlt,
} from '@carbon/react/icons';

import { Overview, Groups, Users, Settings, News, SpotTimetable, Tags, DefaultStreams } from './Pages';
import { OnlineUsers } from './Pages/OnlineUsers';
import {
  HolidaysPage,
  GroupHolidaysPage,
  YearOpeningHoursPage,
} from './Pages/Holidays';
import { useMatches, Outlet, NavLink } from 'react-router-dom';

import "./_overrides.scss";
import { useSideNavContext } from '@/contexts/SideNavContextProvider';
import { Organisations } from './Pages/Organisations';
import useUser from '@/lib/hooks/useUser';

export const child_routes = [
  {
    index: true,
    element: <Overview />,
  },
  {
    path: 'users',
    element: <Users />,
  },
  {
    path: 'users/online',
    element: <OnlineUsers />,
  },
  {
    path: 'groups',
    element: <Groups />,
  },
  {
    path: 'organisations',
    element: <Organisations />,
  },
  {
    path: 'features',
    element: <Settings />,
  },
  {
    path: 'tags',
    element: <Tags />,
  },
  {
    path: 'default-streams',
    element: <DefaultStreams />,
  },
  {
    path: 'spots',
    element: <SpotTimetable />,
  },
  {
    path: 'holidays',
    element: <HolidaysPage />,
  },
  {
    path: 'holidays/groups',
    element: <GroupHolidaysPage />,
  },
  {
    path: 'holidays/year',
    element: <YearOpeningHoursPage />,
  },
  {
    path: 'news',
    element: <News />,
  },
];

const AdminPage = () => {
  return (
    <>
      <Outlet />
    </>
  );
};


export const AdminPageSideNav = () => {
  const {isAdmin} = useUser();
  const matches = useMatches();
  const {setVisibility, maximized} = useSideNavContext();

  useEffect(() => {
    setVisibility(true);
    console.info('AdminPageSideNav');
    return () => {
      setVisibility(false);
      console.info("AdminPageSideNav unmounted");
    }
  }, [setVisibility]);

  //console.info("Matches:", matches);

  return (isAdmin && <SideNav
    expanded={maximized}
    isChildOfHeader={false}
    aria-label="Admin Settings"
  >
    <SideNavItems>
      <SideNavLink
        renderIcon={InventoryManagement}
        as={NavLink}
        to="/admin"
      >
        Übersicht
      </SideNavLink>
      <SideNavMenu
        renderIcon={UserMultiple}
        title="Benutzerverwaltung"
        isExpanded={matches.find(m => m.pathname === "/admin/users" || m.pathname === "/admin/users/online" || m.pathname === "/admin/organisations")}
      >
        <SideNavMenuItem
          renderIcon={UserMultiple}
          as={NavLink}
          to="/admin/users">
          Benutzer
        </SideNavMenuItem>
        <SideNavMenuItem
          renderIcon={UserMultiple}
          as={NavLink}
          to="/admin/users/online">
          Online-Benutzer
        </SideNavMenuItem>
        <SideNavMenuItem
          renderIcon={UserMultiple}
          as={NavLink}
          to="/admin/organisations">
          Organisationen
        </SideNavMenuItem>
      </SideNavMenu>
      <SideNavLink
        renderIcon={Categories}
        as={NavLink}
        to="/admin/groups">
        Gruppen
      </SideNavLink>
      <SideNavLink
        renderIcon={ChartNetwork}
        as={NavLink}
        to="/admin/features">
        Features
      </SideNavLink>
      <SideNavLink
        renderIcon={Tag}
        as={NavLink}
        to="/admin/tags">
        Tags
      </SideNavLink>
      <SideNavLink
        renderIcon={PlayFilledAlt}
        as={NavLink}
        to="/admin/default-streams">
        Default-Streams
      </SideNavLink>
      <SideNavLink
        renderIcon={Industry}
        as={NavLink}
        to="/admin/spots">
        Spots Timetable
      </SideNavLink>
      <SideNavMenu
        renderIcon={Calendar}
        title="Feiertage"
        isExpanded={matches.find(m => m.pathname?.startsWith("/admin/holidays"))}
      >
        <SideNavMenuItem
          as={NavLink}
          to="/admin/holidays">
          Stammdaten
        </SideNavMenuItem>
        <SideNavMenuItem
          as={NavLink}
          to="/admin/holidays/groups">
          Pro Gruppe
        </SideNavMenuItem>
        <SideNavMenuItem
          as={NavLink}
          to="/admin/holidays/year">
          Öffnungszeiten
        </SideNavMenuItem>
      </SideNavMenu>
      <SideNavLink
        renderIcon={Bullhorn}
        as={NavLink}
        to="/admin/news">
        Nachrichten
      </SideNavLink>
    </SideNavItems>
  </SideNav>)
}

export default AdminPage;
